/**
 * @fileoverview Estilos da tela "Abordagens inteligentes": a página, os
 * filtros, o selo de estado e a prévia da sequência. A lista e o editor usam os
 * estilos do "Gerenciar Triagens" (mesma linguagem: linhas, campos, botões).
 * Neutro; cor só no estado (ativo) e no aviso de template com problema.
 */

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => {
  const isDark = theme.palette.type === "dark";
  const textPrimary = isDark ? "#f0f2f5" : "#111318";
  const textSecondary = isDark ? "#a0aec0" : "#4b5563";
  const border = isDark ? "rgba(255,255,255,0.08)" : "rgba(15,23,42,0.12)";
  const inputBorder = isDark ? "rgba(255,255,255,0.16)" : "rgba(0,0,0,0.2)";
  const surface = isDark ? "#111318" : "#ffffff";
  const rowHover = isDark ? "rgba(255,255,255,0.04)" : "rgba(15,23,42,0.035)";
  const t = "all 160ms cubic-bezier(0.4, 0, 0.2, 1)";

  return {
    page: {
      padding: "28px 32px 40px",
      minHeight: "100%",
      fontFamily: "'Montserrat', sans-serif",
      "& *": { fontFamily: "'Montserrat', sans-serif" },
      [theme.breakpoints.down("sm")]: { padding: "20px 16px 32px" },
    },
    header: {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      gap: 16,
      marginBottom: 20,
      flexWrap: "wrap",
    },
    title: { fontSize: 22, fontWeight: 600, color: textPrimary, display: "flex", alignItems: "center", gap: 10 },
    subtitle: { fontSize: 12.5, color: textSecondary, marginTop: 4, maxWidth: 640, lineHeight: 1.5 },
    banner: {
      padding: "12px 14px",
      borderRadius: 10,
      fontSize: 13,
      lineHeight: 1.45,
      marginBottom: 12,
      border: `1px solid ${border}`,
      background: isDark ? "rgba(148,163,184,0.08)" : "#f8fafc",
      color: textSecondary,
    },
    filters: { display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 12 },
    filterBtn: {
      height: 32,
      padding: "0 12px",
      borderRadius: 999,
      border: `1px solid ${inputBorder}`,
      background: surface,
      color: textSecondary,
      fontSize: 12.5,
      fontWeight: 600,
      fontFamily: "inherit",
      cursor: "pointer",
      transition: t,
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      "&:hover": { background: rowHover },
      "&:focus-visible": { outline: `2px solid ${textPrimary}`, outlineOffset: 2 },
    },
    filterBtnOn: {
      background: textPrimary,
      borderColor: textPrimary,
      color: surface,
      "&:hover": { background: textPrimary },
    },
    filterCount: { fontWeight: 500, opacity: 0.75 },
    chipActive: {
      background: isDark ? "rgba(34,197,94,0.14)" : "#dcfce7",
      color: isDark ? "#86efac" : "#166534",
    },
    issue: { display: "flex", alignItems: "flex-start", gap: 6, marginTop: 6 },
    // No celular o texto da linha usa a largura toda e as ações vão para baixo.
    rowMain: { [theme.breakpoints.down("xs")]: { flexBasis: "100%" } },
    // Quem só vê a lista: a linha não abre o editor.
    rowReadOnly: { cursor: "default" },
    rowDesc: { [theme.breakpoints.down("xs")]: { whiteSpace: "normal" } },
    rowActions: { [theme.breakpoints.down("xs")]: { marginLeft: "auto" } },
    // Campo numérico estreito com a explicação ao lado (embaixo, no celular).
    numberRow: {
      display: "grid",
      gridTemplateColumns: "minmax(0, 220px) minmax(0, 1fr)",
      gap: 12,
      alignItems: "center",
      [theme.breakpoints.down("xs")]: { gridTemplateColumns: "1fr", gap: 6 },
    },
    // Prévia da sequência no editor: uma linha por mensagem, com o balão.
    timeline: { display: "flex", flexDirection: "column", gap: 12 },
    timelineItem: { display: "flex", flexDirection: "column", gap: 6 },
    timelineLabel: { fontSize: 12, fontWeight: 600, color: textSecondary, display: "flex", alignItems: "center", gap: 6 },
    timelineStop: { fontSize: 12.5, color: textSecondary, lineHeight: 1.5 },
  };
});

export default useStyles;
